import type { TPortfolioPriceSyncStatus } from "../constants/portfolio.constants";

export const PORTFOLIO_PRICE_UPDATED_EVENT = "portfolio-price-updated";
export const PORTFOLIO_PRICE_SYNC_EVENT = "portfolio-market-price-sync";

export interface PortfolioPriceUpdatedPayload {
  portfolioIds: string[];
  symbolId: string;
  priceDate: string;
  data?: {
    operationId: string;
    cutoffDate: string;
    valuationChanged: boolean;
    status: TPortfolioPriceSyncStatus;
  };
}
